import { Route, Routes } from "react-router-dom";
import ReportsModule from ".";

const ReportsRoute = () => {
  return (
    <Routes>
      <Route path="/:view" element={<ReportsModule />} />
      <Route path="/*" element={<ReportsModule />} />
    </Routes>
  );
};

export default ReportsRoute;
